import promo from '../imgs/TV logo.jpg';
import promo1 from '../imgs/startupsingam2.jpeg'
import '../css/Homepro.css'
import { useNavigate } from 'react-router-dom';
import React, { useRef, useEffect, useState } from 'react';
import { motion } from "framer-motion";

export const Homeproject = () => {
const navigate = useNavigate();
      const handleongoing = () => {
    navigate('/ongoingprojects');
  }
        const handleongoing1 = () => {
    navigate('/comingsoon');
  }
  return (
    <div>

<section className="promo-wrapper">
      <svg className="wave-bg" viewBox="0 0 1440 320">
        <path
          fill="#f0f4f8"
          fillOpacity="1"
          d="M0,160L48,176C96,192,192,224,288,229.3C384,235,480,213,576,208C672,203,768,213,864,202.7C960,192,1056,160,1152,154.7C1248,149,1344,171,1392,181.3L1440,192L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
        />
      </svg>

      <motion.div
        className="promo-card"
        onClick={handleongoing}
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h3>Completed Projects</h3>
        <img src={promo} alt="Startup" />
        <p>
          <span className="highlight">Startup Singam</span> <span>→ Get Info</span>
        </p>
      </motion.div>

      <motion.div
        className="promo-card"
        onClick={handleongoing1}
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
      >
            <h3>On Going Projects </h3>
        <img src={promo1} alt="Upcoming" />
        <p>
          <span className="highlight">Upcoming Startup <br />Singam Season 2</span>{" "}
          <span>→ Get Info</span>
        </p>
      </motion.div>
    </section>

    </div>
  )
}
